import { jsx } from "react/jsx-runtime";
import { Popover, List } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { LinkList } from "../../LinkList/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { selectorAnalyticsKeys } from "./constants.js";
import { getLinkListEntryId, getAriaLabel } from "./lib.js";
import { locationSelectorContainer, locationSelectorStyle } from "./styles.js";
function Selector({
  entry,
  hideTitle = false,
  locale,
  moduleSettings
}) {
  if (!entry) {
    console.error("Selector missing required prop: entry");
    return null;
  }
  const linkListEntryId = getLinkListEntryId(
    entry.active_state.properties
  );
  if (!linkListEntryId) {
    console.error(
      "Selector could not parse LinkList reference from active_state.properties"
    );
    return null;
  }
  const link_type = entry.link_type;
  const { title } = entry.active_state.active_state_link;
  let buttonAriaLabel;
  if (moduleSettings) {
    buttonAriaLabel = getAriaLabel(moduleSettings, title);
  }
  return /* @__PURE__ */ jsx(
    Popover,
    {
      buttonAriaLabel,
      buttonText: title,
      hasArrow: false,
      hasChevronDownIcon: true,
      labelledById: title,
      position: "bottom",
      roleRegion: true,
      setFocus: "First Actionable",
      triggerAction: "onClick",
      uniqueId: "LocationSelectorPopover",
      children: /* @__PURE__ */ jsx(CostcoBox, { sx: locationSelectorContainer, children: /* @__PURE__ */ jsx(
        List,
        {
          sx: {
            margin: 0
          },
          variant: "SimpleList",
          children: /* @__PURE__ */ jsx(
            Analytics,
            {
              analyticData: {
                component: {
                  trackedData: [selectorAnalyticsKeys[link_type]]
                }
              },
              children: /* @__PURE__ */ jsx(
                LinkList,
                {
                  entryId: linkListEntryId,
                  hideTitle,
                  locale,
                  sx: locationSelectorStyle
                }
              )
            }
          )
        }
      ) })
    }
  );
}
export {
  Selector
};
